<template>
  <div class="adm-content-item" v-if="value">
    <h5 class="adm-content-item__title">
      <a :href="value.url" target="_blank" rel="noopener noreferrer">
        <slot name="checkbox"></slot>
        <span style="color: #3c3c3c" :title='"编号：" + value.id'>{{ !!value.title ? value.title : "" }}</span>
        <span style="font-weight: normal; color: #999999; mergin-left: 50px">（{{ value.year }}）</span>
        <small class="adm-content-item__type" title="在新窗口打开">
          <iv-icon type="md-open" size="16" />
        </small>
      </a>
      <span class="pull-right">
        <span v-if="value.audit == 2" :title="'审批批注：'+value.comment">
          <iv-icon type="ios-information-circle" size="16"
            color="#2d8cf0" style="margin-right:5px"></iv-icon>
        </span>
        {{ ['','未审核','不通过','已通过'][value.audit] }}
      </span>
    </h5>
    <div class="adm-content-item__detail">
      <div class="adm-content-item__meta">
        <span class="adm-content-item__meta-show">行业：{{ value.industry }}</span>
        <span class="adm-content-item__meta-show" :title="value.companyInfo.companyName">公司名称： {{ value.companyInfo.abbreviation }}</span>
        <span class="adm-content-item__meta-show">舆情指标： {{ value.secondTargetName }}</span>
        <span class="adm-content-item__meta-show">数量： {{ value.number }}</span>
      </div>

      <div class="adm-content-item__meta">
          <span class="adm-buttons">
            <iv-button size='small' type="primary" @click="$operationLog.show({type:'sentiment',sentimentType:'negative', sentimentId: value.id})">查看日志</iv-button>
            <slot name="buttons"></slot>
          </span>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.adm-content-item {
  padding: 10px 12px;
  color: #999999;
  &__title {
    font-size: 12px;
    margin-bottom: 0.5em;
    padding: 5px 0 0 0;
    small {
      color: #aaa;
      font-weight: normal;
      margin-left: 0.625em;
    }
    .item_edit {
      color: #2d8cf0;
      &:hover {
        cursor: pointer;
      }
    }
  }
  &__detail {
    display: flex;
    justify-content: space-between;
  }
  &__meta {
    display: flex;
    flex-grow: 1;
     &:nth-child(2) {
      max-width: 200px;
      flex-grow: 0;
    }
    .adm-buttons{
      display: flex;
      flex-direction: row;
      /* margin-right: 10px; */
      margin-bottom: 5px;
      a{
        margin-right: 10px;
      }
    }
    > div{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      display: block;
      font-size: 12px;
    }
    &-show {
      font-size: 12px;
      padding: 0 20px 0 0;
      // min-width: 150px;
      /* display: flex; */
      /* align-items: center; */
      // margin-bottom: 5px;
      // min-width: 150px;
      // display: inline-block;
      // font-size: 12px;
      // &:nth-child(1) {
      //   margin-left:0;
      // }
    }
  }
}
</style>
<script>
export default {
  props: {
    value: Object,
    type: {
      type: String,
      default: "draft",
    },
    showLogButton: Boolean,
  }
};
</script>
